var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98712 13.2886C6.7641 13.2886 4.01172 13.7759 4.01172 15.7275C4.01172 17.6791 6.74664 18.1838 9.98712 18.1838C13.2101 18.1838 15.9617 17.6957 15.9617 15.7449C15.9617 13.7941 13.2276 13.2886 9.98712 13.2886Z",
    stroke: "#1E232C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98692 10.5047C12.102 10.5047 13.8163 8.78966 13.8163 6.67458C13.8163 4.5595 12.102 2.84521 9.98692 2.84521C7.87184 2.84521 6.15676 4.5595 6.15676 6.67458C6.14962 8.78252 7.85279 10.4976 9.95994 10.5047H9.98692Z",
    stroke: "#1E232C",
    strokeWidth: 1.19048,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogo);
export default __webpack_public_path__ + "static/media/profileLogo.bcc93fca2a3fa5d72b8b7e43138749d4.svg";
export { ForwardRef as ReactComponent };